<template lang="pug">
  .flooring-tiles
    Configuration(v-if="buyRequest.children[0]" :buy-request="buyRequest.children[0]" @update="update")
    hr
    tile-calculator(v-if="sku === 'RGAKTIVPRO-GROUP'" :buy-request="buyRequest")
    flooring-related-products(:group-meta="meta" :buy-requests="buyRequest.children")
</template>
<script>
import { useProductStore } from '@/js/stores/productStore'
import FlooringRelatedProducts from './related-products.vue'
import TileCalculator from './tile-calculator.vue'
import { createBuyRequest, getBuyRequestMeta } from '../../../helpers/buy-request'

export default {
  name       : 'FlooringTiles',
  components : { TileCalculator, FlooringRelatedProducts },
  props      : {
    buyRequest: {
      type     : Object,
      required : true,
    },
    sku: {
      type     : String,
      required : true,
    },
  },
  data() {
    return {
      meta: {},
    }
  },
  setup() {
    const productStore = useProductStore()

    return { productStore }
  },
  computed: {
    products() {
      return this.productStore.products
    },
  },
  watch: {
    buyRequest: {
      deep      : true,
      immediate : true,
      handler() {
        this.meta = getBuyRequestMeta(this.buyRequest, this.$rogue)
      },
    },
  },
  methods: {
    update() {
      const selectedProduct = this.products[this.buyRequest.children[0].children[0].productId]
      this.buyRequest.children.forEach(configBr => {
        const config = this.products[configBr.productId]
        const child = config.childrenIds.find(childId => {
          const p = this.products[childId]

          return p.attributes.percentage === selectedProduct.attributes.percentage && p.attributes.regu_color === selectedProduct.attributes.regu_color
        })
        if (child) {
          configBr.children[0] = createBuyRequest(this.products[child], this.$rogue)
        }
      })
    },
  },
}
</script>
